module.exports = __webpack_public_path__ + "static/img/Banner.c6044dcf.gif";